module.exports = __webpack_public_path__ + "static/media/05.eaabb11b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/05.jpg
// module id = 374
// module chunks = 0